/*global formObj */
// Set the month from the calendar
function MonthFilter_SetMonth(dt) {
    // Set year dropdown
    var obj, i;
    obj = document.getElementById('Start');
    for (i = 0; i < obj.options.length; i++) {
        if (obj.options[i].value.toString() === dt.toString()) {
            obj.selectedIndex = i;
            break;
        }
    }

    // Reload by ajax
    formObj.SubmitWithValidation(0);
}